import { FontStyles } from "../../constants";
import FormSubSection from "../../CommonFields/FormSubSection";
import { FormColorPicker, FormInputWithUnit, FormSelect } from "../../../../components/FormFields";

const VolumeDesignFreeGift = () => {
    return (
        <div>
            <div id="free-gift-header">
                <FormSubSection rowLabel={"Header"}>
                    <FormColorPicker name="bundles_design.free_gift_header_bg_color" label="Background Color" />
                    <FormColorPicker name="bundles_design.free_gift_header_color" label="Text Color" />
                    <FormInputWithUnit
                        name="bundles_design.free_gift_header_size"
                        min={0}
                        label="Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.free_gift_header_style"
                        label="Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="free-gift-product">
                <FormSubSection rowLabel={"Product"}>
                    <FormColorPicker name="bundles_design.free_gift_bg_color" label="Selected Background Color" />
                    <FormColorPicker name="bundles_design.free_gift_text_color" label="Text Color" />
                    <FormInputWithUnit
                        name="bundles_design.free_gift_text_size"
                        min={0}
                        label="Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.free_gift_text_style"
                        label="Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>

            <div id="free-gift-compare-at-price">
                <FormSubSection rowLabel={"Compare at Price"} hideSeparator>
                    <FormColorPicker
                        name="bundles_design.free_gift_compare_price_color"
                        label="Compare-at Price Color"
                    />
                    <FormInputWithUnit
                        name="bundles_design.free_gift_compare_price_size"
                        min={0}
                        label="Compare-at Price Size"
                        placeholder="font size"
                        unitSuffix="px"
                    />
                    <FormSelect
                        name="bundles_design.free_gift_compare_price_style"
                        label="Compare-at Price Style"
                        options={FontStyles}
                        placeholder="Font style"
                    />
                </FormSubSection>
            </div>
        </div>
    );
};

export default VolumeDesignFreeGift;
